<script>
import Vue from 'vue'
import httpClient from '@/api/httpClient'
import { BootstrapVue } from 'bootstrap-vue'
import PortalVue from 'portal-vue'

Vue.use(BootstrapVue)
Vue.use(PortalVue)

export default {
  name: 'BaseComponent',
  beforeMount () {
    if (typeof this.$t !== 'function') {
      this.$t = value => value
    }
    if (this.$http !== httpClient) {
      this.$http = httpClient
    }
  }
}
</script>

<style>
@import '@/assets/css/bootstrap.min.css';
@import '@/assets/css/bootstrap-vue.css';
@import '@/assets/css/vue-multiselect.min.css';
@import '@/assets/css/fonts/Awesome/font-awesome.css';
</style>
